// extracted by mini-css-extract-plugin
export default {"price":"J5-z","onSale":"K5-z","msrpLabelPrice":"L5-z","msrpLabel":"M5-z","originalPrice":"N5-z","percentOff":"O5-z"};